import { actionCreatorFactory } from 'typescript-fsa';
import { AccountPermission } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('ASSET/PERMISSIONS');
const fetchPermissions = createAction.async<void, AccountPermission[], Error>('FETCH');

export { fetchPermissions };
